module.exports = __webpack_public_path__ + "resources/img/img_dsm1_m_jp.ce7efcd3509bb7818c32b87707fc3446.png";